<template>
    <div class="vue-toggle" :class="{'open': open}">
        <div class="toggle-header" @click="open = ! open">
            {{ title }}
        </div>
        <div class="toggle-content" v-show-slide="open">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "Toggle",

    props: ['title'],

    data() {
        return {
            open: false
        }
    }
}
</script>